import styled from '@emotion/styled'
import {theme} from '../../features/Dashboard/theme'

export const FiltersBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: end;
  margin-bottom: 16px;
  flex-wrap: wrap;
  gap: 12px;
  padding: 15px 15px 0;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
    padding: 12px 12px 0;
    gap: 10px;
    min-width: 0;
  }
`

export const TabsRow = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
  background: ${theme.colors.border};
  border-radius: ${theme.radius.md};

  @media (max-width: 768px) {
    flex-wrap: nowrap;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    min-width: 0;
    width: 100%;

    &::-webkit-scrollbar {
      display: none;
    }
  }
`

export const FilterTab = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 7px 14px;
  font-size: 13px;
  font-weight: ${props => (props.active ? '600' : '400')};
  font-family: ${theme.font.family};
  color: ${props => (props.active ? theme.colors.surface : theme.colors.muted)};
  background: ${props =>
    props.active
      ? 'linear-gradient(0deg,rgba(73, 70, 153, 1) 0%, rgba(37, 42, 100, 1) 100%)'
      : 'none'};
  border: 1px solid
    ${props => (props.active ? theme.colors.primary : 'transparent')};
  border-radius: ${theme.radius.md};
  cursor: pointer;
  transition: all ${theme.transition.fast};
  white-space: nowrap;

  &:hover {
    border-color: ${props =>
      props.active ? theme.colors.primary : theme.colors.muted};
    color: ${props =>
      props.active ? theme.colors.surface : theme.colors.text};
  }

  &:focus {
    outline: none;
  }

  @media (max-width: 768px) {
    padding: 6px 10px;
    font-size: 12px;
    flex-shrink: 0;
  }
`

export const TabCount = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 20px;
  height: 20px;
  padding: 0 5px;
  border-radius: ${theme.radius.md};
  font-size: 11px;
  font-weight: 700;
  background: rgba(255, 255, 255, 0.5);
  color: ${props => (props.active ? theme.colors.surface : theme.colors.muted)};
`

export const RightControls = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  width: 50%;
  justify-content: end;

  @media (max-width: 768px) {
    width: 100%;
    flex-direction: column;
    justify-content: flex-start;
    gap: 8px;
  }
`

export const SearchWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  width: 60%;

  @media (max-width: 768px) {
    width: 100%;
    flex: none;
  }
`

export const SearchIconWrap = styled.span`
  position: absolute;
  left: 10px;
  color: ${theme.colors.placeholder};
  font-size: 13px;
  pointer-events: none;
  line-height: 1;
`

export const SearchInput = styled.input`
  padding: 8px 32px 8px 32px;
  border: 1px solid ${theme.colors.border};
  border-radius: ${theme.radius.lg};
  font-size: 14px;
  color: ${theme.colors.text};
  width: 100%;
  outline: none;
  transition: border-color ${theme.transition.fast};

  &::placeholder {
    color: ${theme.colors.placeholder};
  }

  &:focus {
    border-color: ${theme.colors.muted};
  }
`

export const ClearSearchBtn = styled.button`
  position: absolute;
  right: 10px;
  display: flex;
  align-items: center;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  color: ${theme.colors.placeholder};
  font-size: 15px;
  line-height: 1;

  &:hover {
    color: ${theme.colors.muted};
  }

  &:focus {
    outline: none;
  }
`

export const DateRangeWrapper = styled.div`
  position: relative;
  width: 40%;

  @media (max-width: 768px) {
    width: 100%;
  }
`

export const DateRangeTrigger = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 8px 12px;
  border: 1px solid
    ${props => (props.hasValue ? theme.colors.muted : theme.colors.border)};
  border-radius: ${theme.radius.lg};
  font-size: 13px;
  font-family: ${theme.font.family};
  color: ${props =>
    props.hasValue ? theme.colors.text : theme.colors.placeholder};
  cursor: pointer;
  white-space: nowrap;
  transition: border-color ${theme.transition.fast};
  width: 100%;

  &:hover {
    border-color: ${theme.colors.muted};
  }

  &:focus {
    outline: none;
  }
`

export const CalendarPopout = styled.div`
  position: absolute;
  top: calc(100% + 6px);
  right: 0;
  z-index: 300;
  background: ${theme.colors.surface};
  border: 1px solid ${theme.colors.border};
  border-radius: ${theme.radius.lg};
  box-shadow: ${theme.shadow.popout};
  overflow: hidden;

  @media (max-width: 768px) {
    right: auto;
    left: 0;
    max-width: calc(100vw - 24px);
  }
`
